import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { IconChevronRight, IconPoint } from '@tabler/icons-react';
import { groupOf, sum, EXACT } from './nav';
import type { IconCmp, Zone } from './zone';
import s from './shell.module.css';

const Ic = ({ icon: I, size }: { icon?: IconCmp; size: number }) => (I ? <I size={size} stroke={1.9} /> : <IconPoint size={size} stroke={1.9} />);

/** Menu gom nhóm theo module (MINT NAV KIT v1): mục trên cùng · cụm · nhóm mở/đóng · mục con có số đếm.
 *  Nhóm chứa màn đang mở tự mở; người dùng bấm thì nhớ trong phiên. */
export function NavTree({ zone, active, iconSize = 17, onGo }: { zone: Zone; active: string | null; iconSize?: number; onGo?: () => void }) {
  const [open, setOpen] = useState<Record<string, boolean>>({});
  const actGroup = groupOf(zone, active)?.key;
  return (
    <div className={s.navScroll}>
      {zone.topSection && (zone.top ?? []).length > 0 && <div className={`${s.sec} ${s.secTop}`}>{zone.topSection}</div>}
      {(zone.top ?? []).map((it) => (
        <Link activeOptions={EXACT} key={it.key} to={it.to} className={s.item} aria-current={it.key === active ? 'page' : undefined} onClick={onGo}>
          <Ic icon={it.icon} size={iconSize} />
          <span>{it.label}</span>
          {it.n ? <span className={s.cnt}>{it.n}</span> : null}
        </Link>
      ))}
      {zone.nav.map((g) => {
        const isAct = g.key === actGroup;
        const o = open[g.key] ?? isAct;
        const total = sum(g);
        return (
          <div key={g.key} style={{ display: 'contents' }}>
            {g.section && <div className={s.sec}>{g.section}</div>}
            <button
              type="button"
              className={`${s.grp} ${isAct ? s.grpAct : ''}`}
              aria-expanded={o}
              onClick={() => setOpen({ ...open, [g.key]: !o })}
            >
              <Ic icon={g.icon} size={iconSize} />
              <span>{g.label}</span>
              {!o && total > 0 && <span className={s.sum}>{total > 99 ? '99+' : total}</span>}
              <IconChevronRight size={14} className={s.chev} aria-hidden="true" />
            </button>
            {o && (
              <div className={s.sub}>
                {g.items.map((it) => (
                  <Link activeOptions={EXACT} key={it.key} to={it.to} className={s.item} aria-current={it.key === active ? 'page' : undefined} onClick={onGo}>
                    <span>{it.label}</span>
                    {it.n ? <span className={s.cnt}>{it.n}</span> : null}
                  </Link>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export { Ic as NavIcon };
